import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userSignOut } from "../appRedux/actions";

const SESSION_KEYS = [
  "user_token",
  "user",
  "userId",
  "id",
  "vendor_selected_url",
  "startDate",
  "endDate",
  "sortByV",
];

export const clearSession = (userActivityKey) => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem(userActivityKey);
};

const useIdleLogout = (userActivityKey, panelIdealTime = 15) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const idleMinutes = Number(panelIdealTime);
    if (idleMinutes === 0) {
      return;
    }

    let lastWrite = 0;

    const markActive = () => {
      const now = Date.now();
      localStorage.setItem(userActivityKey, String(now));
      lastWrite = now;
    };

    const handleActivity = () => {
      const now = Date.now();
      if (now - lastWrite > 1000) {
        markActive();
      }
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];
    events.forEach((event) => window.addEventListener(event, handleActivity));

    if (!localStorage.getItem(userActivityKey)) {
      markActive();
    }

    const intervalId = setInterval(() => {
      const lastActivity = Number(localStorage.getItem(userActivityKey));
      if (!lastActivity || Date.now() - lastActivity >= (idleMinutes * 60 * 1000)) {
        clearSession(userActivityKey);
        dispatch(userSignOut());
        window.location.href = "/signin";
      }
    }, 10000);

    const handleStorageChange = (event) => {
      if (
        (event.key === "user_token" || event.key === null) &&
        !localStorage.getItem("user_token")
      ) {
        dispatch(userSignOut());
        window.location.href = "/signin";
      }
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearInterval(intervalId);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch, userActivityKey, panelIdealTime]);
};

export default useIdleLogout;
